import React from "react";

export const Attach = () => (
    <svg width="8px" height="15px" viewBox="0 0 8 15" version="1.1">
        <g
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            transform="translate(-512.000000, -181.000000)"
        >
            <g transform="translate(40.000000, 25.000000)" fill="#C0CBD9">
                <g transform="translate(0.000000, 153.000000)">
                    <g transform="translate(471.666667, 3.000000)">
                        <path
                            d="M0.85,11 C-1.27629629,11 -3,9.43299662 -3,7.5 C-3,5.56700338 -1.27629629,4 0.85,4 L8.2,4 C9.7463973,4 11,5.13963882 11,6.54545455 C11,7.95127027 9.7463973,9.09090909 8.2,9.09090909 L2.25,9.09090909 C1.28350169,9.09090909 0.5,8.37863483 0.5,7.5 C0.5,6.62136517 1.28350169,5.90909091 2.25,5.90909091 L7.5,5.90909091 L7.5,6.86363636 L2.25,6.86363636 C1.86340068,6.86363636 1.55,7.14854607 1.55,7.5 C1.55,7.85145393 1.86340068,8.13636364 2.25,8.13636364 L8.2,8.13636364 C8.66412886,8.13636364 9.1092482,7.96875048 9.43743687,7.67039715 C9.76562553,7.37204382 9.95,6.96738987 9.95,6.54545455 C9.95,6.12351922 9.76562553,5.71886527 9.43743687,5.42051194 C9.1092482,5.12215861 8.66412886,4.95454545 8.2,4.95454545 L0.85,4.95454545 C-0.6963973,4.95454545 -1.95,6.09418427 -1.95,7.5 C-1.95,8.90581573 -0.6963973,10.0454545 0.85,10.0454545 L7.5,10.0454545 L7.5,11 L0.85,11 L0.85,11 Z"
                            id="Shape"
                            transform="translate(4.000000, 7.500000) scale(-1, 1) rotate(-90.000000) translate(-4.000000, -7.500000) "
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Dependency = () =>( <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" >
    <g id="request_form_700х550_4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-627.000000, -182.000000)" opacity="0.64">
        <g id="Group-3" transform="translate(40.000000, 25.000000)" stroke="#C0CBD9">
            <g id="Group-4">
                <g id="menu/set_date" transform="translate(0.000000, 153.000000)">
                    <g id="dependency" transform="translate(588.833333, 5.000000)">
                        <rect id="Rectangle-34" x="-0.5" y="-0.5" width="6" height="6"></rect>
                        <rect id="Rectangle-34" x="7.5" y="6.5" width="6" height="6"></rect>
                        <polyline id="Path-5" points="2.62232372 5.26169034 2.62232372 9.5652066 6.21179315 9.56520672"></polyline>
                        <path d="M4.80078125,8.45611489 L4.80078125,10.7376667 L6.04744175,9.55315241 L4.80078125,8.45611489 Z" id="Path-6"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)

export const Field = () =>  (
<svg width="21px" height="14px" viewBox="0 0 21 14" version="1.1" >
    <g id="request_form_700х550_4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-398.000000, -182.000000)">
        <g id="Group-3" transform="translate(40.000000, 25.000000)" fill="#C0CBD9" fillRule="nonzero">
            <g id="Group-4">
                <g id="menu/set_date" transform="translate(0.000000, 153.000000)">
                    <g id="Group-3" transform="translate(358.500000, 4.000000)">
                        <g id="field-icon">
                            <path d="M1,10.9966488 C1,12.1051188 1.89262061,13 2.99420208,13 L17.0057979,13 C18.1048161,13 19,12.1026525 19,10.9966488 L19,3.00335124 C19,1.89488124 18.1073794,1 17.0057979,1 L2.99420208,1 C1.8951839,1 1,1.89734747 1,3.00335124 L1,10.9966488 Z M2.99420208,0 L17.0057979,0 C18.6594501,0 20,1.34237885 20,3.00335124 L20,10.9966488 C20,12.6553538 18.656688,14 17.0057979,14 L2.99420208,14 C1.34054993,14 0,12.6576211 0,10.9966488 L0,3.00335124 C0,1.34464615 1.34331197,0 2.99420208,0 Z" id="Rectangle-33"></path>
                            <polygon id="Path-4" points="3 11 4 11 4 3 3 3"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)


export const Play = () => (
    <svg width="9px" height="11px" viewBox="0 0 9 11" version="1.1" >
        <g id="request_form_700х550_4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-179.000000, -183.000000)">
            <g id="Group-3" transform="translate(40.000000, 25.000000)" fill="#C0CBD9">
                <g id="Group-4">
                    <g id="menu/set_date" transform="translate(0.000000, 153.000000)">
                        <g id="Group-5" transform="translate(139.166667, 5.000000)">
                            <polygon id="Play-timetracker" points="5.68434189e-14 0 8 4.9465694 0.00886581703 11"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const Subtask = () => (
    <svg width="12px" height="10px" viewBox="0 0 12 10" version="1.1" >
    <g id="request_form_700х550_4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-270.000000, -183.000000)">
        <g id="Group-3" transform="translate(40.000000, 25.000000)" fill="#C0CBD9">
            <g id="Group-4">
                <g id="menu/set_date" transform="translate(0.000000, 153.000000)">
                    <g id="subtask" transform="translate(230.333333, 5.000000)">
                        <g id="subtask-icon">
                            <rect id="Rectangle-32" x="0" y="0" width="11" height="2"></rect>
                            <rect id="Rectangle-32" x="0" y="8" width="2" height="2"></rect>
                            <rect id="Rectangle-32" x="0" y="4" width="2" height="2"></rect>
                            <polygon id="Rectangle-32" points="4 8 11 8 11 10 6.6311242 10 4 10"></polygon>
                            <polygon id="Rectangle-32" points="4 4 11 4 11 6 6.6311242 6 4 6"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)
export const Sharing = () =>(
    <svg width="16px" height="17px" viewBox="0 0 16 17" version="1.1" >
    <g id="request_form_700х550_4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-680.000000, -180.000000)">
        <g id="Group-3" transform="translate(40.000000, 25.000000)" stroke="#C0CBD9">
            <g id="Group-4">
                <g id="menu/set_date" transform="translate(0.000000, 155.000000)">
                    <g id="Group-9" transform="translate(640.000000, 0.000000)">
                        <g id="Group-6">
                            <g id="sharing">
                                <circle id="Oval-7" cx="3.5" cy="8.5" r="3"></circle>
                                <circle id="Oval-7" cx="12.5" cy="3.5" r="3"></circle>
                                <circle id="Oval-7" cx="12.5" cy="13.5" r="3"></circle>
                                <path d="M9.90286067,12.0190202 L6.44352437,9.86027675" id="Path-7"></path>
                                <path d="M9.90286067,7.01902017 L6.44352437,4.86027675" id="Path-7" transform="translate(8.173193, 5.939648) scale(1, -1) translate(-8.173193, -5.939648) "></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)

export const Smile = () => (
    <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" >
    <g id="request_form_700х550_4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-705.000000, -542.000000)" opacity="0.3">
        <g id="comments" transform="translate(40.000000, 525.000000)" fill="#8097B1" fillRule="nonzero">
            <g id="smile" transform="translate(665.000000, 17.000000)">
                <path d="M7.49332229,0.0374463904 C3.35699401,0.0374463904 0.00404421017,3.39039619 0.00404421017,7.52672447 C0.00404421017,11.6630528 3.35699401,15.0160026 7.49332229,15.0160026 C11.6296506,15.0160026 14.9826004,11.6630528 14.9826004,7.52672447 C14.9826004,3.39039619 11.6296506,0.0374463904 7.49332229,0.0374463904 Z M7.49332229,1.08594532 C11.044738,1.08594532 13.9341014,3.97530881 13.9341014,7.52672447 C13.9341014,11.0781401 11.044738,13.9675036 7.49332229,13.9675036 C3.94190663,13.9675036 1.05254314,11.0781401 1.05254314,7.52672447 C1.05254314,3.97530881 3.94190663,1.08594532 7.49332229,1.08594532 Z M5.62399848,6.59056471 C5.62399848,7.1073249 5.20459891,7.52672447 4.68783872,7.52672447 C4.17107854,7.52672447 3.75167896,7.1073249 3.75167896,6.59056471 C3.75167896,6.07380453 4.17107854,5.65440495 4.68783872,5.65440495 C5.20459891,5.65440495 5.62399848,6.07380453 5.62399848,6.59056471 Z M11.240957,6.59056471 C11.240957,7.1073249 10.8215575,7.52672447 10.3047973,7.52672447 C9.7880371,7.52672447 9.36863753,7.1073249 9.36863753,6.59056471 C9.36863753,6.07380453 9.7880371,5.65440495 10.3047973,5.65440495 C10.8215575,5.65440495 11.240957,6.07380453 11.240957,6.59056471 Z"></path>
                <path d="M7.49541929,11.5709346 C6.05598004,11.5709346 4.83447879,10.8901593 4.23533654,9.78099718 C4.23533654,9.78099718 4.17542232,9.67764514 4.17542232,9.62297341 C4.17542232,9.50014925 4.27502972,9.40054185 4.39785388,9.40054185 L4.86892947,9.40054185 C5.03594037,9.40054185 5.18722379,9.48142605 5.29731617,9.60799485 C5.81557422,10.2003967 6.60194842,10.5239336 7.49541929,10.5239336 L7.49766608,10.5239336 C8.39038802,10.5239336 9.17676222,10.2003967 9.69576919,9.60799485 C9.80586158,9.48142605 9.95639607,9.40054185 10.1241559,9.40054185 L10.5952315,9.40054185 C10.7180557,9.40054185 10.817663,9.50014925 10.817663,9.62297341 C10.817663,9.67764514 10.7577488,9.78099718 10.7577488,9.78099718 C10.1586066,10.8901593 8.93710532,11.5709346 7.49766608,11.5709346 L7.49541929,11.5709346 Z" id="mouth_close"></path>
            </g>
        </g>
    </g>
</svg>
)

export const Calendar = () => (
<svg width="12px" height="14px" viewBox="0 0 12 14" version="1.1" >
    <g id="request_form_700х550_4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-65.000000, -181.000000)">
        <g id="Group-3" transform="translate(40.000000, 25.000000)">
            <g id="Group-4">
                <g id="menu/set_date" transform="translate(0.000000, 155.000000)">
                    <g id="Group" transform="translate(25.000000, 1.000000)">
                        <g id="set-date">
                            <rect id="Rectangle" fill="#C0CBD9" x="0" y="1" width="12" height="13" rx="1"></rect>
                            <g id="Group-4" transform="translate(0.500000, 0.000000)" fill="#C0CBD9">
                                <circle id="Oval" cx="1" cy="1" r="1"></circle>
                                <circle id="Oval-Copy" cx="4" cy="1" r="1"></circle>
                                <circle id="Oval-Copy-2" cx="7" cy="1" r="1"></circle>
                                <circle id="Oval-Copy-3" cx="10" cy="1" r="1"></circle>
                            </g>
                            <g id="Group-10" transform="translate(2.000000, 4.000000)" fill="#FFFFFF">
                                <rect id="Rectangle-2" x="0" y="6" width="2" height="2"></rect>
                                <rect id="Rectangle-2-Copy" x="0" y="3" width="2" height="2"></rect>
                                <rect id="Rectangle-2-Copy-2" x="3" y="3" width="2" height="2"></rect>
                                <rect id="Rectangle-2-Copy-7" x="3" y="0" width="2" height="2"></rect>
                                <rect id="Rectangle-2-Copy-5" x="3" y="6" width="2" height="2"></rect>
                                <rect id="Rectangle-2-Copy-3" x="6" y="3" width="2" height="2"></rect>
                                <rect id="Rectangle-2-Copy-6" x="6" y="0" width="2" height="2"></rect>
                                <rect id="Rectangle-2-Copy-4" x="6" y="6" width="2" height="2"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)